import { useQuery } from "@tanstack/react-query";

import { getThemes } from "../../api/Theme";
import { ITheme } from "../../typings/Theme";

export const useThemes = () => {
  return useQuery<ITheme[]>(["themes"], () => getThemes());
};
